import {
  Pouzivatel as PouzivatelGenerated,
  PouzivatelApi,
} from 'iam-frontend-ts-axios';
import apiConfiguration from '../../configuration/apiConfiguration';
import { iamPrefixPath } from '../../configuration/apiConfigurationConstants';
import { ClientResponse } from '../../../model/ClientResponse';
import Uuid from '../../../model/Uuid';
import { Pouzivatel } from '../../../model/iam/Pouzivatel';

const client = new PouzivatelApi(apiConfiguration(iamPrefixPath));

function map(pouzivatel: PouzivatelGenerated[]): Pouzivatel {
  if (!pouzivatel) {
    return null;
  }
  return {
    uuid: pouzivatel[0].userUUID,
    nazov: pouzivatel[0].fullName,
    nazovPozicie: pouzivatel[0].nazovPozicie,
  };
}

// eslint-disable-next-line import/prefer-default-export
export const fetchPouzivatel = async (
  userId?: string,
  userUuid?: Uuid,
  // eslint-disable-next-line default-param-last
  execute = true,
  headers?: object,
): Promise<ClientResponse<Pouzivatel>> => {
  if (!execute) {
    return {
      data: null,
      responseCode: null,
    };
  }
  const {
    data,
    status,
  } = await client.getPouzivatel(userId, userUuid, headers);
  return {
    data: map(data),
    responseCode: status,
  };
};
